import React from 'react';
import AppRoutes from '../routes';
import Footer from '../components/madnest/footer';
import Header from '../components/madnest/header';
import HomePage from '../pages/madnest/home_page';
import AboutPage from '../pages/madnest/about_page';
import ContactPage from '../pages/madnest/contact_page';


export default function MadnestTemplate(props) {
    return (
        <React.Fragment>
            <Header />
            <AppRoutes
                homePage={HomePage}
                contactPage={ContactPage}
                aboutPage={AboutPage}
                
            />
            <Footer />
        </React.Fragment>
    )
}
